import { makeDocumentAPIs } from '../../modules/documentAPIFactory'
import { getCompanyMSServiceDocumentListData } from './mockData'
import type { ICompanyMSServiceDocument } from '~/types/document/models'

export const {
  getDocuments: getCompanyMSServiceDocuments,
  postDocument: postCompanyMSServiceDocument,
  patchDocument: patchCompanyMSServiceDocument,
  deleteDocument: deleteCompanyMSServiceDocument,
  handlers,
} = makeDocumentAPIs<ICompanyMSServiceDocument>({
  apiPathEntityNamePrefix: 'companymsservice',
  getDocumentListDataFn: getCompanyMSServiceDocumentListData,
})
